import CardType from "@app/enum/dashboard/CardType";

import CardFeature from "../enum/CardFeature";

const cardFeatures: Record<CardType, CardFeature[]> = {
  [CardType.ACTIVITIES_LOGGED]: [CardFeature.ACTIVITIES, CardFeature.GOAL],
  [CardType.ACTIVITIES_OVERDUE]: [CardFeature.ACTIVITIES, CardFeature.GOAL],
  [CardType.CHECK_INS]: [CardFeature.ACTIVITIES, CardFeature.GOAL],
  [CardType.CLOSED_STAGE_DEAL_AMOUNT]: [CardFeature.DEALS, CardFeature.GOAL],
  [CardType.CLOSED_STAGE_DEAL_COUNT]: [CardFeature.DEALS, CardFeature.GOAL],
  [CardType.CUSTOMER_FACE_TIME]: [CardFeature.ACTIVITIES, CardFeature.GOAL],
  [CardType.MILEAGE_TRACKING]: [CardFeature.GOAL],
  [CardType.NEW_RECORDS]: [
    CardFeature.COMPANIES,
    CardFeature.DEALS,
    CardFeature.PEOPLE,
    CardFeature.GOAL,
  ],
  [CardType.NEW_ROUTES]: [CardFeature.COMPANIES, CardFeature.PEOPLE, CardFeature.GOAL],
  [CardType.NO_CONTACT_IN]: [CardFeature.COMPANIES, CardFeature.DEALS, CardFeature.PEOPLE],
  [CardType.NO_CONTACT_IN_COUNT]: [
    CardFeature.COMPANIES,
    CardFeature.DEALS,
    CardFeature.PEOPLE,
    CardFeature.GOAL,
  ],
  [CardType.OPEN_STAGE_DEAL_AMOUNT]: [CardFeature.DEALS, CardFeature.GOAL],
  [CardType.OUT_OF_FREQUENCY]: [
    CardFeature.COMPANIES,
    CardFeature.DEALS,
    CardFeature.PEOPLE,
    CardFeature.GOAL,
  ],
  [CardType.RECORDS_PAST_DUE]: [
    CardFeature.COMPANIES,
    CardFeature.DEALS,
    CardFeature.PEOPLE,
    CardFeature.GOAL,
  ],
  [CardType.UPCOMING_ACTIVITIES]: [CardFeature.COMPANIES, CardFeature.DEALS, CardFeature.PEOPLE],
};

const hasFeature = (card: CardType, feature?: CardFeature) =>
  feature ? cardFeatures[card].includes(feature) : true;

export default hasFeature;
